<template>
  <div>
    <b-row
      v-if="stockSlip.id"
      class="col-md-12 mb-1 m-0 p-0"
    >
      <label class="font-weight-bold">
        Mã phiếu kho: <a class="text-primary">{{ stockSlip.code }}</a>
      </label>
    </b-row>
    <b-row>
      <StockSlipBase
        :stockSlip="stockSlip"
        :stockSlipOptions="stockSlipOptions"
        :stores="stores"
        provider-label-field="fullName"
        :providers="providers"
        :reasons="reasons"
        :is-hide-provider="isHideProvider"
        :editable="editable"
        @onSelectedStore="$emit('onSelectedStore', $event)"
        @onInputChangeStore="$emit('onInputChangeStore', $event)"
        @onSelectedProvider="$emit('onSelectedProvider', $event)"
        @onInputChangeProvider="$emit('onInputChangeProvider', $event)"
        @onSelectedReason="$emit('onSelectedReason', $event)"
        @onInputChangeReason="$emit('onInputChangeReason', $event)"
        @onFetchProvider="$emit('onFetchProvider')"
      />
    </b-row>
    <b-row class="col-md-12 mb-1 m-0 p-0">
      <StockSlipProduct
        :editable="editable"
        :product-items="stockSlip.details"
        :store-id="stockSlip.storeId"
        :in-stock="inStock"
        :from-warranty="fromWarranty"
      />
    </b-row>
    <hr
      class="hr-text"
      data-content="Bút Toán"
      style="font-weight: 600"
    />
    <b-row v-if="stockSlip.code">
      <b-col md="12">
        <StockSlipTransactions :stock-code="stockSlip.code" />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import StockSlipBase from './StockSlipBase.vue';
import StockSlipProduct from './StockSlipProduct.vue';
import StockSlipTransactions from './StockSlipTransactions.vue';

export default {
  name: 'StockSlipImportExportBody',
  components: {
    StockSlipBase,
    StockSlipProduct,
    StockSlipTransactions,
  },
  props: {
    stockSlip: {
      type: Object,
      required: true,
    },
    stockSlipOptions: {
      type: Array,
      default: () => [],
    },
    stores: {
      type: Array,
      default: () => [],
    },
    providers: {
      type: Array,
      default: () => [],
    },
    reasons: {
      type: Array,
      default: () => [],
    },
    editable: {
      type: Boolean,
      default: false,
    },
    inStock: {
      type: Boolean,
      default: false,
    },
    fromWarranty: {
      type: Boolean,
      default: false,
    },
    isHideProvider: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
